import { CC_NUMBER_CHINA_B2B } from "@international-transfer/consts/country";
import {
  ENDPOINTS_PLATFORM_WHITELIST_FLAG,
  ENDPOINTS_ITR_WHITELIST_FLAG,
  ENDPOINTS_TRX_DEFAULT_FLAG
} from "src/consts/api";
import { KEY } from "src/consts/nexus-keys";
import { NexusData } from "src/types/nexus";

// All of the data from nexus should have default value defined here
export const DEFAULT_NEXUS_DATA: NexusData = {
  [KEY.IT_VALIDATION_FIELD]: {
    payload: {
      CHN: {
        account_number: {
          cc_number: CC_NUMBER_CHINA_B2B
        }
      }
    }
  },
  [KEY.FLAG_ENDPOINT_TRX_MICROSERVICES]: {
    payload: {
      endpoint: ENDPOINTS_TRX_DEFAULT_FLAG
    }
  },
  [KEY.COMPANY_CUSTOM_FILTER_START_DATE]: {
    payload: {
      transaction_history: []
    }
  },
  [KEY.FLAG_ENDPOINT_CMS]: {
    payload: {
      company_id: []
    }
  },
  [KEY.FLAG_ENDPOINT_ONBOARDING]: {
    payload: {
      ...ENDPOINTS_PLATFORM_WHITELIST_FLAG
    }
  },
  [KEY.FLAG_ENDPOINT_ITR]: {
    payload: {
      endpoint: ENDPOINTS_ITR_WHITELIST_FLAG
    }
  },
  // Mid-session refetch dedupe floor (seconds). Nexus can override; see refetch-controller.ts.
  [KEY.NEXUS_REFETCH_CONFIG]: { payload: { ttl_seconds: 60 } },
  // Per-group onboarding flags default to toggle "off" (legacy) until Nexus enables them.
  // Groups defined in src/api/new-interfaces/live/api-dashboard.csv.
  [KEY.GENERAL]: { payload: { toggle: "off" } },
  [KEY.API_INFO]: { payload: { toggle: "off" } },
  [KEY.MODULE_ACCESS_OTP]: { payload: { toggle: "off" } },
  // Default off = legacy MultiInput page.
  [KEY.NEW_ITR_FLOW]: { payload: { toggle: "off" } },
  // Default off -- "Persetujuan Transaksi" (maker-approver) flow.
  [KEY.ITR_MAKER_APPROVER_FLOW]: { payload: { toggle: "off" } },
  [KEY.FLAG_ENDPOINT_PAY]: {
    payload: {
      get_payment_links: false,
      transaction_report: false,
      settlement_report: false
    }
  },
  // Refund stays off until Nexus turns it on.
  [KEY.PAY_REFUND_FLAGS]: { payload: { enabled: false } },
  // Riwayat Pembayaran stays on v1 until Nexus turns v2 on.
  [KEY.PAY_HISTORY_V2]: { payload: { enabled: false } },
  // Default off = show whatever account number the backend returned.
  [KEY.HARDCODE_BRI_ACCOUNT_TOPUP]: { payload: { toggle: "off" } }
};
